module.exports = __webpack_public_path__ + "static/crew-tracker-logo-d683aec97ad2f6a6300ba08ea3b7bfd5.svg";